export const privilegeSchema = {
  is_accountant_role: {
    type: Boolean,
  },
  is_subcontract_role: {
    type: Boolean,
  },
  is_pm_role: {
    type: Boolean,
  },
  is_lob_lead_role: {
    type: Boolean,
  },
  is_management_role: {
    type: Boolean,
  },
  is_hr_admin_role: {
    type: Boolean,
  },
  is_hr_admin_confidential_role: {
    type: Boolean,
  },
  is_hr_subcontract_role: {
    type: Boolean,
  },
  is_vp_avp_role: {
    type: Boolean,
  },
  is_display_pps_role: {
    type: Boolean,
  },
  is_project_approver_role: {
    type: Boolean,
  },
  is_project_acknowledge_role: {
    type: Boolean,
  },
  is_salesman_role: {
    type: Boolean,
  },
  is_submit_efficiency_role: {
    type: Boolean,
  },
  is_not_count_headcount: {
    type: Boolean,
  },
}

export const filterRole = values => {
  const _values = { ...values }
  Object.keys(values).map(key => {
    if (!privilegeSchema[key]) {
      delete _values[key]
      return key
    }
    return key
  })
  return _values
}



// WEBPACK FOOTER //
// ./src/components/new-employee/schema/privilege-schema.js